import { createContext } from "react";

const ValidationContext = createContext({
  answer: null,
});

export default ValidationContext;
